import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  getAgentsInput,
  getAgentInput,
  AgentLiteModel,
  AgentModel,
} from './model';

export function useGetAgents(
  input?: getAgentsInput,
  options?: UseQueryOptions<ExtendedApiResult<AgentLiteModel[]>, ApiError>,
): UseQueryResult<ExtendedApiResult<AgentLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getAgents', input?.params],
      () =>
        QueryFetchFunction({
          url: 'agents',
          params: input?.params,
        }),
      options,
    ),
    AgentLiteModel,
  );
}

export function useGetAgent(
  input?: getAgentInput,
  options?: UseQueryOptions<ApiResult<AgentModel>, ApiError>,
): UseQueryResult<ApiResult<AgentModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getAgent', input?.id],
      () => QueryFetchFunction({ url: `agents/${input?.id}` }),
      options,
    ),
    AgentModel,
  );
}

export function getAgentsKey(input?: getAgentsInput) {
  return ['getAgents', input?.params];
}

export function getAgentKey(input?: getAgentInput) {
  return ['getAgent', input?.id];
}
